import React from 'react';

export const FileAndUploadButton = ({ file, fileUrl, uploaded }) =>
{
    return file?.name ?
        <div>
            <div>
                <b>File:</b> { file.name + " " }
                <span className="badge bg-primary">{ file.size } kb</span>
            </div>
            {
                !uploaded ?
                <button className="btn btn-primary" type="submit">
                    Upload File
                </button> :
                <div className="text-success">
                    { "✅ " }
                    <a href={fileUrl} target="_blank" rel="noopener noreferrer">
                        File
                    </a>
                    { " Uploaded Successfully ✅" }
                </div>
            }
        </div> :
        null;
};
